import HeadsetWorkingMode from 'src/components/atoms/HeadsetWorkingMode/HeadsetWorkingMode';

export default HeadsetWorkingMode;
